import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "snackbar-content" }

import { computed } from 'vue';
import { useStore } from 'vuex';

// 다중레이아웃 처리 app.vue

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

// 스낵바 상태 가져오기
const snackbar = computed(() => store.getters.snackbar);

// 스낵바 숨기기 함수
const hideSnackbar = () => {
  store.commit('hideSnackbar');
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$route.meta.layout || 'div'), { style: {"background-color":"#F4F5FA"} }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: snackbar.value.timeout,
      location: "bottom",
      class: "global-snackbar"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          onClick: hideSnackbar,
          icon: "mdi-close",
          size: "small"
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(snackbar.value.text), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color", "timeout"])
  ], 64))
}
}

})